import { TabContentItem } from '@services/ui-services/models/tab-content';

export const FILTER_GROUP_DATA = [
  {
    label: 'data',
    icon: 'person',
    icon_class: 'success-100',
    data: [
      {
        join_condition_by: 'string',
        name: 'Business Name',
        fieldName: 'first_name',
        icon: 'balance',
        radio: true,
        toggle: true,
        isShow: true,
        details: {
          label: 'Business Name',
          content: 'Triggered when a user completes their pruchase in the checkout flow.',
        },
      },
      {
        join_condition_by: 'string',
        name: 'Pancard Number',
        fieldName: 'business__pancard_number',
        icon: 'person',
        radio: true,
        toggle: true,
        isShow: true,
        details: {
          label: 'Joined date',
          content: 'Triggered when a user completes their pruchase in the checkout.',
        },
      },
      {
        join_condition_by: 'string',
        name: 'Phone Number',
        fieldName: 'phone',
        icon: 'jam_phone',
        radio: true,
        toggle: true,
        isShow: true,
        details: {
          label: 'Joined date',
          content: 'Triggered when a user completes their pruchase in the checkout.',
        },
      },
      {
        join_condition_by: 'string',
        name: 'City',
        fieldName: 'addresses__city',
        icon: 'location',
        radio: true,
        toggle: true,
        isShow: true,
        details: {
          label: 'Joined date',
          content: 'Triggered when a user completes their pruchase in the checkout.',
        },
      },
      {
        join_condition_by: 'string',
        name: 'State',
        fieldName: 'addresses__state',
        icon: 'location',
        radio: true,
        toggle: true,
        isShow: true,
        details: {
          label: 'Joined date',
          content: 'Triggered when a user completes their pruchase in the checkout.',
        },
      },
      {
        join_condition_by: 'string',
        name: 'Pin Code',
        fieldName: 'addresses__pincode',
        icon: 'location',
        radio: true,
        toggle: true,
        isShow: true,
        details: {
          label: 'Joined date',
          content: 'Triggered when a user completes their pruchase in the checkout.',
        },
      },
    ],
  },
  // {
  //   label: 'events',
  //   icon: 'calendar',
  //   icon_class: 'light-100',
  //   data: [
  //     {
  //       join_condition_by: 'string',
  //       name: 'Account Completed',
  //       fieldName: 'event_name',
  //       icon: 'balance',
  //       radio: true,
  //       toggle: true,
  //       isShow: true,
  //       details: {
  //         label: 'Account Completed',
  //         content: 'user completes their pruchase in the checkout flow.',
  //       },
  //     },
  //     {
  //       join_condition_by: 'string',
  //       name: 'KYC Approved',
  //       fieldName: 'event_name',
  //       icon: 'balance',
  //       radio: true,
  //       toggle: true,
  //       isShow: true,
  //       details: {
  //         label: 'KYC Approved',
  //         content:
  //           'Triggered when a user completes their pruchase in the checkout flow.',
  //       },
  //     },
  //     {
  //       join_condition_by: 'string',
  //       name: 'Cart Abandoned',
  //       fieldName: 'event_name',
  //       icon: 'balance',
  //       radio: true,
  //       toggle: true,
  //       isShow: true,
  //       details: {
  //         label: 'Cart Abandoned',
  //         content:
  //           'Triggered when a user completes their pruchase in the checkout flow.',
  //       },
  //     },
  //   ],
  // },
  // {
  //   label: 'attributes',
  //   icon: 'calendar',
  //   icon_class: 'light-100',
  //   data: [
  //     {
  //       join_condition_by: 'price',
  //       name: 'Average order value',
  //       fieldName: 'avg_order_value',
  //       icon: 'balance',
  //       radio: true,
  //       toggle: true,
  //       isShow: true,
  //       details: {
  //         label: 'Average order value',
  //         content: 'user completes their pruchase in the checkout flow.',
  //       },
  //     },
  //     {
  //       join_condition_by: 'number',
  //       name: 'Club ai point balance',
  //       fieldName: 'club_ai_point_balance',
  //       icon: 'balance',
  //       radio: true,
  //       toggle: true,
  //       isShow: true,
  //       details: {
  //         label: 'Club ai point balance',
  //         content:
  //           'Triggered when a user completes their pruchase in the checkout flow.',
  //       },
  //     },
  //     {
  //       join_condition_by: 'date',
  //       name: 'Last seen',
  //       fieldName: 'last_seen',
  //       icon: 'balance',
  //       radio: true,
  //       toggle: true,
  //       isShow: true,
  //       details: {
  //         label: 'Last seen',
  //         content:
  //           'Triggered when a user completes their pruchase in the checkout flow.',
  //       },
  //     },
  //   ],
  // },
];

export const FILTER_ATTRIBUTES = [
  { name: 'Price', icon: 'balance', radio: true, toggle: true },
  {
    name: 'Quote type',
    icon: 'change_circle',
    radio: false,
    toggle: false,
  },
  { name: 'Quote type', icon: 'change_circle', radio: false, toggle: false },
];

export const FILTER_DROPDOWN = [
  {
    name: 'Price',
    icon: 'balance',
    radio: true,
    toggle: true,
    isShow: true,
    details: {
      label: 'Price',
      content: 'Triggered when a user completes their pruchase in the checkout flow.',
    },
  },
  {
    name: 'Quote type',
    icon: 'change_circle',
    radio: true,
    toggle: true,
    isShow: true,
    details: {
      label: 'Quote type',
      content: 'user completes their pruchase in the checkout flow.',
    },
  },
  {
    name: 'Qty',
    icon: 'jam_hashtag',
    radio: true,
    toggle: true,
    isShow: true,
    details: {
      label: 'Qty',
      content: 'Triggered when a user completes their pruchase in the checkout.',
    },
  },
  {
    name: 'Channel',
    icon: 'filter',
    radio: true,
    toggle: true,
    isShow: true,
    details: {
      label: 'Channel',
      content: 'Triggered when a user completes their pruchase in the checkout.',
    },
  },
  {
    name: 'Joined date',
    icon: 'calendar',
    radio: true,
    toggle: true,
    isShow: true,
    details: {
      label: 'Joined date',
      content: 'Triggered when a user completes their pruchase in the checkout.',
    },
  },
  {
    name: 'Joined date',
    icon: 'calendar',
    radio: true,
    toggle: true,
    isShow: true,
    details: {
      label: 'Joined date',
      content: 'Triggered when a user completes their pruchase in the checkout.',
    },
  },
  {
    name: 'Channel',
    icon: 'filter',
    radio: true,
    toggle: true,
    isShow: true,
    details: {
      label: 'Channel',
      content: 'Triggered when a user completes their pruchase in the checkout.',
    },
  },
];

export const FILTER_ACTIVE_INFO = {
  label: 'Price',
  content: 'Triggered when a user completes their pruchase in the checkout flow.',
};

export const FILTER_TAB_CONTENT: TabContentItem[] = [
  { label: 'System', id: 'system', active: false, icon: 'no_icon', value: 'system' },
  { label: 'Custom', id: 'custom', active: true, icon: 'no_icon', value: 'system' },
];

export const FILTER_DETAILS = {
  Price: {
    label: 'Price',
    content: 'Triggered when a user completes their pruchase in the checkout flow.',
  },
  Qty: {
    label: 'Qty',
    content: 'user completes their pruchase in the checkout flow.',
  },
  'Quote type': {
    label: 'Quote type',
    content: 'Triggered when a user completes their pruchase in the checkout.',
  },
  Channel: {
    label: 'Joined date',
    content: 'Triggered when a user completes their pruchase in the checkout.',
  },
  'Joined date': {
    label: 'Joined date',
    content: 'Triggered when a user completes their pruchase in the checkout.',
  },
};

export const STRING_COMPARISON_FILTERS: any = [
  {
    name: 'Contains',
    comparison_key: 'contains',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
    showInput: true,
    multipleInputs: false,
  },
  {
    name: 'Is',
    comparison_key: 'equal',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
    showInput: true,
    multipleInputs: false,
  },
  {
    name: 'Is not',
    comparison_key: 'not-equal',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
    showInput: true,
    multipleInputs: false,
  },
  {
    name: 'Does not contain',
    comparison_key: 'not-exists',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
    showInput: true,
    multipleInputs: false,
  },
  {
    name: 'Starts with',
    comparison_key: 'starts-with',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
    showInput: true,
    multipleInputs: false,
  },
  {
    name: 'Ends with',
    comparison_key: 'ends-with',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
    showInput: true,
    multipleInputs: false,
  },
  {
    name: 'Is empty',
    comparison_key: 'is-empty',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
    showInput: false,
    multipleInputs: false,
  },
  {
    name: 'Is not empty',
    comparison_key: 'is-not-empty',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
    showInput: false,
    multipleInputs: false,
  },
];

export const NUMBER_COMPARISON_FILTERS: any = [
  {
    name: 'Equals',
    comparison_key: 'equals',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
    showInput: true,
    multipleInputs: false,
  },
  {
    name: 'Not Equals',
    comparison_key: 'not-equals',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
    showInput: true,
    multipleInputs: false,
  },
  {
    name: 'Is greater than',
    comparison_key: 'greater_than',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
    showInput: true,
  },
  {
    name: 'Is less than',
    comparison_key: 'less_than',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
    showInput: true,
  },
  {
    name: 'Between',
    comparison_key: 'between',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
    showInput: true,
    multipleInputs: true,
  },
  {
    name: 'Not Between',
    comparison_key: 'not-between',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
    showInput: true,
    multipleInputs: true,
  },
  {
    name: 'Is empty',
    comparison_key: 'is-empty',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
    showInput: false,
    multipleInputs: false,
  },
  {
    name: 'Is not empty',
    comparison_key: 'is-not-empty',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
    showInput: false,
    multipleInputs: false,
  },
];

export const dateOperators: any = [
  {
    name: 'Equals',
    comparison_key: 'equal',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
    showInput: true,
  },
  {
    name: 'Not equal',
    comparison_key: 'not-equal',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
  },
  {
    name: 'Between',
    comparison_key: 'between',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
    showInput: true,
    multipleInputs: true,
  },
  {
    name: 'Since',
    comparison_key: 'greater-or-equal',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showInput: true,
    showIcon: false,
  },
];
export const statusOperators: any = [
  {
    name: 'Equals',
    comparison_key: 'equal',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
    showInput: false,
  },
];

export const LIST_COMPARISON_FILTERS: any = [
  {
    name: 'Equals',
    comparison_key: 'equals',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
  },
  {
    name: 'Does not equal',
    comparison_key: 'not_equal',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
  },
];

export const BOOLEAN_COMPARISON_FILTERS: any = [
  {
    name: 'True',
    comparison_key: 'true',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
    showInput: false,
  },
  {
    name: 'False',
    comparison_key: 'false',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
    showInput: false,
  },
];

export const STRING_ADVANCED_FILTERS: any = [
  { value: 'Contains', label: 'Contains' },
  { value: 'is', label: 'Is' },
  { value: 'is not', label: 'Is not' },
  { value: 'does not contain', label: 'Does not contain' },
  { value: 'starts with', label: 'Starts with' },
  { value: 'ends with', label: 'Ends with' },
  { value: 'is empty', label: 'Is empty' },
  { value: 'is not empty', label: 'Is not empty' },
];

export const EVENTS_COMPARISON_FILTERS: any = [
  {
    name: 'has been performed',
    comparison_key: 'has been performed',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
  },
  {
    name: 'has not been performed',
    comparison_key: 'has not been performed',
    icon: 'subscription',
    color: 'default',
    checkbox: false,
    radio: false,
    toggle: false,
    showIcon: false,
  },
];
